import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock";
import SingleTile from "@/components/TilesModule/variants/TilesBlockImagesNavigation/SingleTile";
import {getCssSizeValue, getMapKey} from "@/utils/utils";
import GridContainer from "@/components/common/GridContainer";
import styled from "styled-components";
import {BREAKPOINTS} from "@/styles/themeSettings";

const Wrapper = styled(GridContainer)`
	row-gap: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
	
    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
        row-gap: ${getCssSizeValue(24, BREAKPOINTS.TABLET)};
    }

    @media (min-width: ${({theme}) => theme.breakpoints.desktop}px) and (orientation: landscape) {
		row-gap: var(--row-gap);
    }
`

export default function TilesBlockImagesNavigation({ data, paddings, headerDescription }) {
	const tiles = data?.tiles || ''

	return <section className={paddings}>
		<HeaderDescriptionBlock headerDescription={headerDescription} />
		<Wrapper>
			{tiles.map((tile, index) => <SingleTile key={getMapKey(tile, index)} tile={tile} />)}
		</Wrapper>
	</section>
}
